<template>
  <div>
    <v-container grid-list-lg fluid>
      <v-layout row wrap>
        <v-flex lg12 md12 sm12>
          <v-layout row wrap class="align-center mb-2">
            <v-flex lg2 md3 sm6 xs12>
              <v-select :items="orderDateType" item-value="value" item-text="name" v-model="selectedDateType" label="Chọn ngày" hide-details></v-select>
            </v-flex>
            <v-flex lg2 md3 sm6 xs12>
              <v-menu
                v-model="menuStart"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="computedStartDateFormatted"
                    label="Từ ngày"
                    hint="DD-MM-YYYY"
                    persistent-hint
                    prepend-icon="fa-calendar-alt"
                    readonly
                    v-on="on"
                    hide-details
                  ></v-text-field>
                </template>
                <v-date-picker v-model="dateRange.startDate" no-title @input="menuStart = false"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex lg2 md3 sm6 xs12>
              <v-menu
                v-model="menuEnd"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="computedEndDateFormatted"
                    label="Đến ngày"
                    hint="DD-MM-YYYY"
                    persistent-hint
                    prepend-icon="fa-calendar-alt"
                    readonly
                    v-on="on"
                    hide-details
                  ></v-text-field>
                </template>
                <v-date-picker v-model="dateRange.endDate" no-title @input="menuEnd = false"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex lg3 md3 sm6 xs12>
              <v-select :items="orderStatus" item-value="value" item-text="name" v-model="selectedStatus" label="Trạng thái cuối" hide-details></v-select>
            </v-flex>
            <v-flex lg3 md4 sm6 xs12>
              <v-select :items="orderTypeOptions" item-value="value" item-text="name" v-model="selectedOrderType" label="Loại đơn" hide-details></v-select>
            </v-flex>
            <v-flex lg2 md4 sm6 xs12>
              <v-select
                :items="staffTypes"
                item-value="value"
                item-text="name"
                v-model="selectedStaffType"
                label="Nhóm nhân viên"
                hide-details
                @change="selectedStaffID = null"
              ></v-select>
            </v-flex>
            <v-flex lg2 md4 sm6 xs12>
              <v-select
                :items="staffOptions"
                item-value="ID"
                item-text="DisplayName"
                v-model="selectedStaffID"
                label="Nhân viên"
                clearable
                hide-details
              ></v-select>
            </v-flex>
            <v-flex lg3 md4 sm6 xs12>
              <v-autocomplete
                :items="customerOptions"
                item-value="ID"
                item-text="DisplayName"
                v-model="selectedCustomerID"
                label="Khách hàng"
                clearable
                hide-details
              ></v-autocomplete>
            </v-flex>
            <v-flex lg3 md4 sm6 xs12>
              <v-text-field
                v-model="searchOrderCode"
                label="Mã đơn"
                placeholder="MD..., KG... hoặc ID"
                clearable
                hide-details
                @keyup.enter="filter_data"
              ></v-text-field>
            </v-flex>
            <v-flex lg2 md4 sm12 xs12 class="text-right text-lg-center">
              <v-btn @click="filter_data" color="#0088cc" outlined height="40" block>Lọc dữ liệu</v-btn>
            </v-flex>
          </v-layout>
        </v-flex>

        <!-- Biểu đồ Line lợi nhuận -->
        <v-flex lg6 md6 sm12 v-if="chartOptions" class="mb-6 d-flex">
          <v-card class="flex-grow-1">
            <v-card-text>
              <highcharts :options="chartOptions"></highcharts>
            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex lg6 md6 sm12 v-if="groupChartOptions" class="mb-6 d-flex">
          <v-card class="flex-grow-1">
            <v-card-text>
              <v-layout row wrap class="mb-4">
                <v-flex lg6 md6 sm12>
                  <v-select
                    :items="chartGroupTypes"
                    item-value="value"
                    item-text="name"
                    v-model="chartGroupBy"
                    label="Biểu đồ tổng hợp theo"
                    hide-details
                    @change="filter_data"
                  ></v-select>
                </v-flex>
                <v-flex lg6 md6 sm12 v-if="chartGroupBy === 'staff'">
                  <v-select
                    :items="staffTypes"
                    item-value="value"
                    item-text="name"
                    v-model="chartStaffType"
                    label="Nhóm nhân viên trên biểu đồ"
                    hide-details
                    @change="filter_data"
                  ></v-select>
                </v-flex>
              </v-layout>
              <highcharts :options="groupChartOptions"></highcharts>
            </v-card-text>
          </v-card>
        </v-flex>
        
        <!-- Bảng danh sách lợi nhuận theo đơn hàng -->
        <v-flex lg12>
          <v-card class="mb-8">
            <v-card-text>
              <v-layout row wrap>
                <v-flex lg12 md12 sm12>
                  <v-data-table :headers="headers" :items="orders" :loading="loading" :mobile-breakpoint="100" :sort-by="['TotalProfit']" :sort-desc="[true]">
                    <template v-slot:item="{ item }">
                      <tr>
                        <td>
                          <a target="_blank" :href="(item.OrderType === 'KG' ? '/ky-gui/' : '/don-hang/') + item.ID" class="font-weight-bold">
                            {{ item.OrderCode }}
                          </a>
                        </td>
                        <td>{{ item.Username }}</td>
                        <td>{{ item.StaffName }}</td>
                        <td>{{ item.OrderType }}</td>
                        <td>{{ item.OrderDate }}</td>
                        <td class="text-end">{{ item.ProfitExchangeRate | currency }}</td>
                        <td class="text-end">{{ item.ProfitShipping | currency }}</td>
                        <td class="text-end">
                          <span v-if="!isSaleUser">{{ item.ProfitNegotiation | currency }}</span>
                        </td>
                        <td class="text-end">{{ item.ProfitBuying | currency }}</td>
                        <td class="text-end">{{ item.ProfitUTNK | currency }}</td>
                        <td class="text-end">{{ item.ProfitSurcharge | currency }}</td>
                        <td class="text-end">{{ item.ProductAmount | currency }}</td>
                        <td class="text-end">{{ item.Deposit | currency }}</td>
                        <td class="text-end" :class="{'red--text font-weight-bold': item.RemainingAmount > 0}">{{ item.RemainingAmount | currency }}</td>
                        <td class="text-end font-weight-bold">{{ item.TotalProfit | currency }}</td>
                      </tr>
                    </template>
                    <template v-slot:body.append v-if="summary && orders.length > 0">
                      <tr class="total-summary-td">
                        <td colspan="5">TỔNG CỘNG</td>
                        <td class="text-end">{{ summary.ProfitExchangeRate | currency }}</td>
                        <td class="text-end">{{ summary.ProfitShipping | currency }}</td>
                        <td class="text-end">{{ summary.ProfitNegotiation | currency }}</td>
                        <td class="text-end">{{ summary.ProfitBuying | currency }}</td>
                        <td class="text-end">{{ summary.ProfitUTNK | currency }}</td>
                        <td class="text-end">{{ summary.ProfitSurcharge | currency }}</td>
                        <td class="text-end">{{ summary.ProductAmount | currency }}</td>
                        <td class="text-end">{{ summary.Deposit | currency }}</td>
                        <td class="text-end font-weight-bold" :class="{'red--text': summary.RemainingAmount > 0}">{{ summary.RemainingAmount | currency }}</td>
                        <td class="text-end font-weight-bold">{{ summary.TotalProfit | currency }}</td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { Chart } from 'highcharts-vue';
import Highcharts from 'highcharts';
import { mapState } from "vuex";
import configs from "../../configs";
import _ from "lodash";
import moment from "moment";

const setHighchartsNumericSymbols = () => {
    const symbols = ['k', 'M', 'B', 'T', 'P', 'E'];
    if (Highcharts && Highcharts.setOptions) {
        Highcharts.setOptions({ lang: { numericSymbols: symbols } });
    }
    if (typeof window !== 'undefined' && window.Highcharts && window.Highcharts.setOptions) {
        window.Highcharts.setOptions({ lang: { numericSymbols: symbols } });
    }
};
setHighchartsNumericSymbols();

export default {
    components: {
        highcharts: Chart 
    },
    data() {
        return {
            viewName: "bao-cao-doanh-thu",
            dateRange: {
                startDate: moment.utc(Date.now()).startOf('month').toISOString().substr(0, 10),
                endDate: moment.utc(Date.now()).endOf('month').toISOString().substr(0, 10),
            },
            orderDateType: [
                {value: 1, name: 'Ngày tạo đơn'},
                {value: 2, name: 'Ngày mua hàng'},
                {value: 3, name: 'Ngày nhập kho TQ'},
                {value: 4, name: 'Ngày xuất kho TQ'},
                {value: 5, name: 'Ngày nhập kho VN'},
                {value: 6, name: 'Ngày xuất kho VN'},
                {value: 7, name: 'Ngày thanh toán'},
                {value: 8, name: 'Ngày hoàn thành'},
            ],
            orderStatus: [{value: -1, name: 'Tất cả'}, ...configs.ORDER_STATUS],
            staffTypes: [
                { value: 'sale', name: 'Sale' },
                { value: 'purchase', name: 'Mua hàng' },
                { value: 'customer_service', name: 'CSKH' },
                { value: 'officer', name: 'Chứng từ' }
            ],
            chartGroupTypes: [
                { value: 'customer', name: 'Khách hàng' },
                { value: 'staff', name: 'Nhân viên' }
            ],
            menuStart: false,
            menuEnd: false,
            selectedDateType: 1,
            selectedStatus: -1,
            selectedStaffType: 'sale',
            selectedStaffID: null,
            selectedOrderType: 'all',
            orderTypeOptions: [
                { value: 'all', name: 'Tất cả loại đơn' },
                { value: 'MD', name: 'Đơn mua hộ (MD)' },
                { value: 'KG', name: 'Đơn ký gửi (KG)' }
            ],
            selectedCustomerID: null,
            searchOrderCode: '',
            chartGroupBy: 'customer',
            chartStaffType: 'sale'
        };
    },
    computed: {
        ...mapState({
            orders: state => state.report.orderRevenueV2.data.orders || [],
            chart_data: state => state.report.orderRevenueV2.data.chart_data || [],
            group_chart_data: state => state.report.orderRevenueV2.data.group_chart_data || [],
            summary: state => state.report.orderRevenueV2.summary,
            loading: state => state.report.loading,
            staffs: state => state.commons.all_users || [],
            customers: state => (state.customer && state.customer.master && state.customer.master.data) || []
        }),
        customerOptions() {
            return (this.customers || []).map(c => {
                const username = c.Username || c.UserName || '';
                const code = c.UserCode ? ` (${c.UserCode})` : '';
                const fullName = [c.FirstName, c.LastName].filter(Boolean).join(' ') || c.FullName || '';
                const name = fullName ? ` - ${fullName}` : '';
                return {
                    ID: c.ID,
                    DisplayName: `${username}${code}${name}`.trim() || `Khách #${c.ID}`
                };
            });
        },
        staffOptions() {
            const roleMap = {
                sale: configs.ROLE_TYPE.Sale,
                purchase: configs.ROLE_TYPE.Purchase,
                customer_service: configs.ROLE_TYPE.CustomerService,
                officer: configs.ROLE_TYPE.Officer
            };
            const role = roleMap[this.selectedStaffType];
            return _.filter(this.staffs, staff => (staff.RoleType & role) === role).map(staff => ({
                ...staff,
                DisplayName: staff.FullName || staff.Username
            }));
        },
        computedStartDateFormatted () {
            return moment(this.dateRange.startDate).format(configs.SHORT_DATE_FORMAT);
        },
        computedEndDateFormatted () {
            return moment(this.dateRange.endDate).format(configs.SHORT_DATE_FORMAT);
        },
        adminRole() {
            return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin;
        },
        isSaleUser() {
            if (this.adminRole) return false;
            const user = this.$store.state.authentication.user || {};
            const roleType = Number(user.roletype || user.RoleType || 0);
            return (roleType & configs.ROLE_TYPE.Sale) == configs.ROLE_TYPE.Sale || Number(user.IsSaleLeader || 0) === 1;
        },
        headers() {
            return [
                { text: "Mã đơn", value: "OrderCode", sortable: true },
                { text: "Khách hàng", value: "Username", sortable: true },
                { text: "Nhân viên", value: "StaffName", sortable: true },
                { text: "Loại đơn", value: "OrderType", sortable: true },
                { text: "Ngày", value: "OrderDate", sortable: true },
                { text: "CL Tỷ giá", value: "ProfitExchangeRate", align: "end", sortable: true },
                { text: "CL Vận chuyển", value: "ProfitShipping", align: "end", sortable: true },
                { text: "HH Đàm phán", value: "ProfitNegotiation", align: "end", sortable: true },
                { text: "Phí mua hàng", value: "ProfitBuying", align: "end", sortable: true },
                { text: "CL Phí UTNK", value: "ProfitUTNK", align: "end", sortable: true },
                { text: "CL Phụ phí", value: "ProfitSurcharge", align: "end", sortable: true },
                { text: "Tiền hàng", value: "ProductAmount", align: "end", sortable: true },
                { text: "Đã cọc/thanh toán", value: "Deposit", align: "end", sortable: true },
                { text: "Tiền còn thiếu", value: "RemainingAmount", align: "end", sortable: true },
                { text: "Tổng lợi nhuận", value: "TotalProfit", align: "end", sortable: true }
            ];
        },
        chartOptions() {
            if (!this.chart_data || this.chart_data.length === 0) return null;
            return {
                chart: { type: 'line', height: 360 },
                title: { text: 'Biểu đồ xu hướng doanh thu, lợi nhuận' },
                credits: { enabled: false },
                tooltip: { shared: true },
                xAxis: {
                    categories: _.map(this.chart_data, 'OrderDate')
                },
                yAxis: {
                    title: {
                        text: 'Số tiền (VNĐ)'
                    }
                },
                series: [
                    { name: 'Chênh lệch tỷ giá', data: _.map(this.chart_data, 'ProfitExchangeRate') },
                    { name: 'Chênh lệch vận chuyển', data: _.map(this.chart_data, 'ProfitShipping') },
                    { name: 'Hoa hồng đàm phán', data: _.map(this.chart_data, 'ProfitNegotiation') },
                    { name: 'Phí mua hàng', data: _.map(this.chart_data, 'ProfitBuying') },
                    { name: 'Chênh lệch phí UTNK', data: _.map(this.chart_data, 'ProfitUTNK') },
                    { name: 'Chênh lệch phụ phí', data: _.map(this.chart_data, 'ProfitSurcharge') },
                    { name: 'Tiền hàng', data: _.map(this.chart_data, 'ProductAmount') },
                    { name: 'Tổng lợi nhuận', data: _.map(this.chart_data, 'TotalProfit'), dashStyle: 'Dash' }
                ]
            };
        },
        groupChartOptions() {
            if (!this.group_chart_data || this.group_chart_data.length === 0) return null;
            return {
                chart: { type: 'column', height: 300 },
                title: {
                    text: this.chartGroupBy === 'staff'
                        ? 'Báo cáo tổng hợp theo nhân viên'
                        : 'Báo cáo tổng hợp theo khách hàng'
                },
                credits: { enabled: false },
                tooltip: { shared: true },
                xAxis: {
                    categories: _.map(this.group_chart_data, 'ChartLabel'),
                    crosshair: true
                },
                yAxis: {
                    title: { text: 'Số tiền (VNĐ)' }
                },
                series: [
                    { name: 'Chênh lệch tỷ giá', data: _.map(this.group_chart_data, 'ProfitExchangeRate') },
                    { name: 'Chênh lệch vận chuyển', data: _.map(this.group_chart_data, 'ProfitShipping') },
                    { name: 'Hoa hồng đàm phán', data: _.map(this.group_chart_data, 'ProfitNegotiation') },
                    { name: 'Phí mua hàng', data: _.map(this.group_chart_data, 'ProfitBuying') },
                    { name: 'Chênh lệch phí UTNK', data: _.map(this.group_chart_data, 'ProfitUTNK') },
                    { name: 'Chênh lệch phụ phí', data: _.map(this.group_chart_data, 'ProfitSurcharge') },
                    { name: 'Tiền hàng', data: _.map(this.group_chart_data, 'ProductAmount') },
                    { name: 'Tổng lợi nhuận', data: _.map(this.group_chart_data, 'TotalProfit') }
                ]
            };
        }
    },
    methods: {
        getFilterParams() {
            var param = {
                filterType: 0,
                startTime: moment(this.dateRange.startDate).format(configs.SQL_DATE_FORMAT),
                endTime: moment(this.dateRange.endDate).format(configs.SQL_DATE_FORMAT),
                orderStatus: this.selectedStatus,
                dateType: this.selectedDateType,
                staffType: this.selectedStaffType,
                chartGroupBy: this.chartGroupBy,
                chartStaffType: this.chartStaffType
            };
            if (this.selectedStaffID != null && this.selectedStaffID !== '') {
                param.staffID = this.selectedStaffID;
            }
            if (this.selectedCustomerID != null && this.selectedCustomerID !== '') {
                param.customerID = this.selectedCustomerID;
            }
            if (this.searchOrderCode && this.searchOrderCode.trim()) {
                param.orderCode = this.searchOrderCode.trim();
            }
            if (this.selectedOrderType && this.selectedOrderType !== 'all') {
                param.orderType = this.selectedOrderType;
            }
            return _.pickBy(param, v => v !== null && v !== undefined && v !== '');
        },
        filter_data: function () {
            var param = this.getFilterParams();
            this.$store.dispatch("report/getOrderRevenueV2Report", param);
        },
        exportReport() {
            if (this.isSaleUser) return;
            var param = this.getFilterParams();
            this.$store.dispatch("report/exportOrderRevenueV2Report", param);
        }
    },
    mounted() {
        setHighchartsNumericSymbols();
        this.$store.dispatch("commons/getAllUsers");
        this.$store.dispatch("customer/getCustomerList", {
            is_master: 1,
            fields: ["ID", "Username", "UserCode", "FirstName", "LastName"]
        });
        if (this.$route.query.staffType) {
            this.selectedStaffType = this.$route.query.staffType;
        }
        if (this.$route.query.staffID) {
            this.selectedStaffID = Number(this.$route.query.staffID);
        }
        if (this.$route.query.dateType) {
            this.selectedDateType = Number(this.$route.query.dateType);
        }
        if (this.$route.query.startDate) {
            this.dateRange.startDate = this.$route.query.startDate;
        }
        if (this.$route.query.endDate) {
            this.dateRange.endDate = this.$route.query.endDate;
        }
        if (this.$route.query.orderStatus) {
            this.selectedStatus = Number(this.$route.query.orderStatus);
        }
        this.filter_data();
        this.$root.$emit('REQUEST_ROOT_OPTION', {
            invisibleSaveButton: this.isSaleUser
        });
        this.$root.$on("REQUEST_SAVE_DATA", this.exportReport);
        this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_SAVE_DATA", this.exportReport);
        this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
    }
};
</script>
<style scoped>
</style>
